import { JSX } from "preact";

type Element =
    | string
    | {
          type: "image";
          src: string;
          shadow?: boolean;
      }
    | { type: "element"; element: JSX.Element };

export interface ChangelogPost {
    date: Date;
    title: string;
    content: Element[];
}

export const changelogEntries: Record<number, ChangelogPost> = {
    1: {
        date: new Date("2026-01-01T00:00:00.000Z"),
        title: "Welcome to Cayble",
        content: [
            "Cayble is a self-hosted messaging platform. Join the Cayble Lounge or create your own server to get started.",
            "You can secure your account with two-factor authentication from your settings, upload files, and customise the app to your liking.",
            "Head over to settings to get started!",
        ],
    },
};

export const changelogEntryArray = Object.keys(changelogEntries).map(
    (index) => changelogEntries[index as unknown as number],
);

export const latestChangelog = changelogEntryArray.length;
